module.exports = __webpack_public_path__ + "static/media/bb.1e2da0d1.svg";